import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { RecipeComponent } from '../../../app/services/api/generated';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

type Props = {
  index: number;
  item: RecipeComponent;
  onRemoveComponent: (index: number) => void;
  open: boolean;
  onClose: () => void;
}

const DeleteRecipeComponentModal: FC<Props> = ({ open, onClose, index, item, onRemoveComponent }) => {

  const { t } = useTranslation('recipe');

  const handleConfirm = () => {
    onRemoveComponent(index);
  };

  return (
    <Dialog open={open}
      onClose={onClose}
      maxWidth='sm'>
      <DialogTitle>
        {t('deleteIngredientTitle')}
        <CloseDialogAction onCancel={onClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('deleteIngredientConfirmation')} {item.componentDescription}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={onClose}> {t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRecipeComponentModal;